/* eslint-disable react-hooks/rules-of-hooks */
import {
  useGoToPathFactory,
  useCreateHrefFactory,
} from '../core/factories/routing/routingHooks.factories'
import { type RouteName } from './routes'

export const useGoToPath = useGoToPathFactory<RouteName>()
export const useCreateHref = useCreateHrefFactory<RouteName>()
